import React, { useContext } from "react";
import { useImmerReducer } from "use-immer";
import { Link, useParams } from "react-router-dom";
import BreakpointContext from "../../contexts/breakpointContext";
import DraftDispatchContext from "../../contexts/draftDispatchContext";
import DraftStateContext from "../../contexts/draftStateContext";
import Box from "../layout/Box";
import TabSection from "../ui/TabSection";
import { draftInitialState, draftReducer } from "./draftReducer";
import Picks from "./Picks";
import Rosters from "./Rosters";

export default function DraftResults() {
  const { league, season } = useParams();
  const breakpoints = useContext(BreakpointContext);
  const [draftState, draftDispatch] = useImmerReducer(
    draftReducer,
    draftInitialState
  );

  const divWidth = !breakpoints.md ? "100%" : "80%";

  return (
    <DraftDispatchContext.Provider value={draftDispatch}>
      <DraftStateContext.Provider value={draftState}>
        <Box title={"draft results"} centerContent={true}>
          <div
            style={{
              background: "white",
              padding: "1rem",
              color: "black",
              width: divWidth,
            }}
          >
            <div
              style={{
                textAlign: "right",
                fontSize: "1rem",
                fontWeight: "bold",
              }}
            >
              <Link to={`/${league}/${season}/draft`}>Live Draft</Link>
            </div>
            <TabSection
              labels={["Picks", "Teams"]}
              panels={[<Picks />, <Rosters />]}
            />
          </div>
        </Box>
      </DraftStateContext.Provider>
    </DraftDispatchContext.Provider>
  );
}
